import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router' ;
import { parse, stringify } from 'flatted';

import { ApiService, DialogsService } from '../../custom-material/Services/';
import { BuildingModel, BuildingTypeModel, DiagnosticModel, UserModel, IncidentModel } from '../../main/Models/';
import { MatTabChangeEvent} from '@angular/material/tabs';
import { globalData } from 'src/app/main/Models/global.model';
import { BaseComponent } from 'src/app/main/Components/base/base.component';
import { toollist } from './building-sheet.tools';

@Component({
  selector: 'building-sheet',
  templateUrl: './t_building-sheet.component.html',
  styleUrls: ['./building-sheet.component.less']
})
export class BuildingSheetComponent extends BaseComponent implements OnInit {

  @Input()
  model: BuildingModel;

  @Output()
  saveTriggered: EventEmitter<BuildingModel> = new EventEmitter();
  @Output()
  deleteTriggered: EventEmitter<number> = new EventEmitter();
  @Output()
  onChange: EventEmitter<any> = new EventEmitter();


  public activedTabIndex:Array<number> = [];
  public activeTabIndex: number = 0 ;
  public handleTabChange(e: MatTabChangeEvent) {
    this.activeTabIndex = e.index;
    if(!this.activedTabIndex.includes(e.index)) this.activedTabIndex.push(e.index);
  }

  constructor(
    private dialogService: DialogsService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    public gd: globalData
    ) { 
      super(gd);
      this.gd.showChooser = false;
      this.gd.headerTitle = "Fiche établissement";
      this.gd.headerIcon = "location_city";
    }

  ngOnInit() {
    let id = +this.route.snapshot.params['building'];
    this.model = this.gd.findBuildingById(id);
    this.gd.headerBuilding = this.model;
    this.gd.toollist = parse(stringify(toollist).replace('$id',''+id));
    this.gd.toolService = this;
  }

  ngAfterViewInit(){
    setTimeout(()=>{ 
      this.activedTabIndex.push(0);
      this.activeTabIndex = 0; 
    }, 50);
  }

  goto(where, suppl='') //incident | statistiques
  {
    this.router.navigate([where+'/'+this.model.id+suppl]);
  }
  gotoIncidents()
  {
    this.gd.selectedBuildingsList = [this.model.id];
    this.router.navigate(['/incidents']);
  }

  delete()
  {
    this.dialogService.confirm('buildingsheet-delete-confirm-message')
        .subscribe(res => {
          if(res) {
            this.apiService.DeleteFromServer('building', this.model)
              .then(s => s.subscribe(
                response => {
                  const place = this.gd.buildings.indexOf(this.model);
                  this.gd.buildings.splice(place,1);
                  this.router.navigate(['/buildings']);
                },
                err => console.log("buildings.delete error", err)
              ) );
          }
        });
  }
}